import css from './Desktop.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Breakpoints } from 'meta/layout/breakpoints'

import { ButtonWhiteBlack } from 'components/Actions/Action'
import { Grid, GridColumn } from 'components/Layout/Grid'
import Img from 'components/Media/Img'
import EventListItemSkeleton from 'components/Pages/Collection/EventList/EventListItem/EventListItemSkeleton'
import { useCurrentLanguage } from 'hooks/useCurrentLanguage'
import { usePerformerBulkDetails } from 'hooks/usePerformer'

interface Props {
  codes: string[]
  setShowLineupModal: (show: boolean) => void
}

const MAX_SHOWN = 5

const ARTIST_ICON_SIZE = 64

const Desktop: React.FC<Props> = (props) => {
  const { codes, setShowLineupModal } = props

  const { t } = useTranslation()
  const language = useCurrentLanguage()
  const data = usePerformerBulkDetails({ codes, language })

  if (!data || data.length != codes.length) {
    return <EventListItemSkeleton />
  }

  return (
    <div className={css.multipleArtistDesktopContainer}>
      <Grid>
        <GridColumn gridColumnStart={{ [Breakpoints.laptop]: 1 }} gridColumnEnd={{ [Breakpoints.laptop]: 13 }}>
          <div className={css.leftSide}>
            <div
              style={{ 'minWidth': (data.slice(0, MAX_SHOWN).length - 1) * ARTIST_ICON_SIZE }}
              className={css.imgContainer}
            >
              {data.slice(0, MAX_SHOWN).map((elem, key) => (
                <img
                  style={{
                    'left': Number(key) * ARTIST_ICON_SIZE - Number(key) * 16,
                    'top': 0,
                    'zIndex': MAX_SHOWN - Number(key),
                  }}
                  key={key}
                  src={elem.assets?.find((x) => x.format == 'SQUARE')?.url}
                  className={css.image}
                />
              ))}
            </div>
            <div className={classNames(css.textContainer, { [css.isLessThanMax]: data.length <= MAX_SHOWN })}>
              <span>
                {data
                  .slice(0, MAX_SHOWN)
                  .map((elem) => elem.name)
                  .join(' • ')
                  .substring(0, 80)
                  .concat(data.length > MAX_SHOWN ? '...' : '')}
              </span>
            </div>
          </div>
        </GridColumn>
        {data.length > MAX_SHOWN && (
          <GridColumn gridColumnStart={{ [Breakpoints.laptop]: 14 }} gridColumnEnd={{ [Breakpoints.laptop]: 16 }}>
            <div className={css.action}>
              <ButtonWhiteBlack
                className={css.button}
                onClick={() => {
                  setShowLineupModal(true)
                }}
              >
                <h5>{t('collection:other_artists', { num: data.length - MAX_SHOWN })}</h5>
                <Img src="/icons/arrow_right.svg" />
              </ButtonWhiteBlack>
            </div>
          </GridColumn>
        )}
      </Grid>
    </div>
  )
}

export default Desktop
